import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// List of common timezones
const timezones = [
  "UTC",
  "America/New_York",
  "America/Los_Angeles",
  "Europe/London",
  "Europe/Berlin",
  "Asia/Kolkata",
  "Asia/Tokyo",
  "Australia/Sydney",
];

export function CalendarWithClock() {
  const [selectedTimezone, setSelectedTimezone] = useState("UTC");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);

  // Update time every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Convert time to selected timezone
  const formattedTime = new Intl.DateTimeFormat("en-US", {
    timeZone: selectedTimezone,
    weekday: "long",  // "Monday"
    year: "numeric",  // "2025"
    month: "long",    // "March"
    day: "numeric",   // "28"
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(currentTime);

  return (
    <div className="p-2  text-gray-900 rounded-lg w-full max-w-md relative">
      {/* Clock Section */}
      <div className="mb-2">
        <div className="items-center space-x-1">
          <select className="  overflow-auto  w-full p-1  rounded-lg  text-textColor"
            value={selectedTimezone}
            onChange={(e) => setSelectedTimezone(e.target.value)}
          >
            {timezones.map((tz) => (
              <option className="bg-greenBg text-white"
              key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
          <div className="bg-white p-1 mt-2 rounded-lg"><span className="text-sm  md:text-md font-bold text-textColor hover:text-greenBg hover:bg-white rounded-lg">
          {formattedTime}
        </span></div>
        </div>
      </div>

      {/* Calendar Section */}
      <div className="relative ">
      {/* Inline Calendar Container */}
      <div className="w-full scale-[0.85] origin-top-left">
  <DatePicker 
    selected={selectedDate}
    onChange={(date) => setSelectedDate(date)}
    inline
    showMonthDropdown
    showYearDropdown
    
  />
</div>
    </div>
    </div>
  );
}